import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

import type { PublicShop } from '@getjust/gateway';

export const useSetDatadogUser = (userId: string | undefined) => {
  useEffect(() => {
    if (userId) {
      datadogRum.setUser({
        id: userId,
      });
    }
  }, [userId]);
};

export const useSetDatadogGlobalContext = (shopData: PublicShop | undefined) => {
  useEffect(() => {
    if (shopData) {
      datadogRum.setGlobalContextProperty('shopId', shopData.id);
      datadogRum.setGlobalContextProperty('shopName', shopData.name);
    }
  }, [shopData]);
};
